import React from 'react';

export default function TextConditionsBrazil() {
  return (
    <div className='text-sm text-gray-400 font-bold px-8'>
      <section className='mb-8'>
      <h3 className='text-lg text-gray-400 font-bold mb-4'>POLÍTICA DE PRIVACIDADE</h3>
      <p>
        A privacidade, a proteção de Dados Pessoais e o seu tratamento de forma
        transparente, ética, segura e responsável são valores essenciais para nós.
      </p>
      <p>
        Esta Política de Privacidade (ou apenas “Política”) explica como a TRAVEL GEA, na
        qualidade de Controladores de Dados Pessoais, coletam, usam, compartilham ou de
        outra forma tratam informações e Dados Pessoais de pessoas físicas, inclusive de
        clientes e de terceiros, para o desempenho de nossas atividades, incluindo pelos
        nossos Sites e Aplicativos. Aqui você também encontra informações sobre os seus
        direitos em relação aos seus Dados Pessoais, de acordo com a LGPD - Lei Geral de
        Proteção de Dados Pessoais (Lei nº 13.709/18), e demais legislações aplicáveis.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        1. ATUALIZAÇÃO DA POLÍTICA DE PRIVACIDADE
      </h4>
      <p>
        Sempre que a TRAVEL GEA entender necessário, a Política de Privacidade poderá sofrer
        alterações que serão publicadas em nossos Sites e Aplicativos. Essas alterações
        serão válidas, eficazes e vinculantes após a nova versão ser divulgada nos nossos
        Sites e Aplicativos ou serem comunicadas de qualquer outra forma a você.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        2. QUAIS INFORMAÇÕES UTILIZAMOS E COMO AS COLETAMOS?
      </h4>
      <p>
        Nós tratamos Dados Pessoais de quem é ou foi nosso cliente ou teve algum
        relacionamento conosco, foi ou é representante, procurador, empregado, sócio de
        algum cliente, empresa ou entidade com a qual nos relacionamos, realizou alguma
        transação conosco ou com nossos clientes, de pessoas com as quais pretendemos nos
        relacionar ou outros titulares de Dados Pessoais.
      </p>
      <br />
      <p>
        Os Dados Pessoais que tratamos variam de acordo as finalidades de uso, inclusive as
        indicadas nessa Política, e com as atividades que realizamos. Esses Dados Pessoais
        incluem dados cadastrais, financeiros e transacionais, tais como:
      </p>
      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>
          Dados cadastrais: nome, data de nascimento, sexo, RG, CPF e/ou outros documentos
          de identificação, tais como carteira de habilitação, passaporte, foto, endereço
          residencial e comercial, telefones residencial, comercial e celular, e-mail,
          profissão, ocupação, estado civil, nacionalidade, naturalidade, entre outros que
          possam ser necessários em casos específicos.
        </li>
        <br />
        <li>
          Informações que acessamos para te entregar uma funcionalidade: caso você autorize
          e para possibilitar determinadas funcionalidades de nossos Sites e Aplicativos,
          como quando tratamos suas fotos e dados de contatos para a criação e envio de
          comprovantes de pagamento.
        </li>
        <br />
        <li>
          Informações sobre hábitos de navegação: páginas e funcionalidades acessadas em
          nossos Sites e Aplicativos, quantidade de cliques, páginas e aplicativos que
          originaram o acesso aos nossos Sites e Aplicativos (por exemplo, se você acessar
          um site que possuir um link para os nossos Sites e Aplicativos, ou se você acessar
          páginas de terceiros a partir de links nos nossos Sites e Aplicativos).
        </li>
        <br />
        <li>
          Dados de mídias e plataformas sociais: interações que você possa ter com nossas
          redes sociais, tais como Facebook, Twitter, Instagram, LinkedIn e YouTube.
        </li>
      </ul>
      <p>
        Os dados podem ser fornecidos diretamente por você, serem coletados em decorrência
        da prestação de serviços ou fornecimento de produtos pela TRAVEL GEA a você (ou a
        você relacionados), ou podem ser fornecidos por outras fontes externas legítimas,
        como parceiros estratégicos, corretoras de seguros, fornecedores, prestadores de
        serviços, instituições do sistema financeiro, bureaus de crédito, órgãos públicos,
        correspondentes e empresas ou órgãos com os quais a TRAVEL GEA ou você possua
        vínculo ou algum tipo de relação direta ou indireta. Também podemos obter Dados
        Pessoais e outras informações de fontes públicas e/ou acessíveis publicamente, como
        Internet, meios de comunicação, mídias sociais e registros públicos e de outras
        fontes, conforme permitido na legislação aplicável.
      </p>
      <br />
      <p>A seguir, indicamos alguns exemplos dessas situações.</p>
      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>
          Dados podem ser fornecidos por você, por exemplo, no preenchimento de cadastros,
          formulários, adesões, contratações, acessos, procura ou manifestação de interesse
          em produtos e serviços.
        </li>
        <br />
        <li>
          Dados que geramos sobre você decorrentes do seu relacionamento com a TRAVEL GEA,
          como por exemplo informações sobre contratação e uso de produtos e serviços ou
          quando você interage conosco pelos nossos Sites, Aplicativos, canais,
          estabelecimentos, centrais e locais de atendimento.
        </li>
        <br />
        <li>
          Dados recebidos de terceiros são aqueles fornecidos por terceiros sobre você,
          mesmo que você não seja cliente da TRAVEL GEA, inclusive por empresas ou órgãos
          com os quais a TRAVEL GEA ou você tenha alguma relação, bem como fornecedores e
          parceiros.
        </li>
        <br />
      </ul>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        3. PARA QUE USAMOS OS SEUS DADOS?
      </h4>
      <p>
        A TRAVEL GEA realiza o tratamento de dados pessoais de acordo com as bases legais
        previstas na Lei Geral de Proteção de Dados (LGPD), como por exemplo, para
        cumprimento de obrigações legais e regulatórias; execução de contrato; proteção do
        crédito; para atender os interesses legítimos da TRAVEL GEA, dos nossos clientes e
        de terceiros; proteção da vida ou da incolumidade física do Titular ou de terceiros;
        nas situações em que o consentimento do Titular dos Dados Pessoais for coletado e
        para o exercício regular de direitos.
      </p>
      <br />
      <p>
        Poderemos tratar Dados Pessoais e outras informações para diversas finalidades
        relacionadas ao desempenho das atividades da TRAVEL GEA, conforme exemplos descritos
        abaixo:
      </p>
      <br />
      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>
          Realizar as nossas atividades, prestar os nossos serviços e fornecer os nossos
          produtos no nosso relacionamento com você:
        </li>
        <br />
        <li>
          realizar e manter o seu cadastro atualizado, verificar sua identidade e eventuais
          outras informações;
        </li>
        <br />
      </ul>
      <ol style={{ listStyle: 'auto', paddingLeft: '1rem' }}>
        <li>
          dar cumprimento e realizar ações relacionadas ao contrato, inclusive etapas
          anteriores à contratação, durante e após a contratação. Atividades como avaliação
          de propostas de contratação, atendimento nos nossos canais e processos
          operacionais para garantir a melhor experiência e atendimento para os nossos
          clientes;
        </li>
        <br />
        <li>
          atender os nossos clientes, potenciais clientes e terceiros, inclusive tratando
          dúvidas, reclamações, solicitações e suporte pelos nossos canais de atendimento,
          possibilitando o seu contato conosco sempre que necessário, e o contrário também;
        </li>
        <br />
        <li>
          envio de comunicações sobre produtos e serviços contratados por você, necessários
          para o cumprimento do contrato;
        </li>
        <br />
        <li>
          avaliações e exercício regular de direitos necessários para execução de contratos,
          como por exemplo, informações sobre a sua saúde necessárias para a contratação de
          determinados produtos, como de seguros, ou ainda para a avaliação de sinistros
          relacionados;
        </li>
        <br />
        <li>seleção e contratação de colaboradores da TRAVEL GEA.</li>
        <br />
      </ol>
      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>
          Entender os nossos clientes e oferecer produtos mais adequados às suas
          necessidades e perfil:
        </li>
        <br />
        <li>
          avaliar o perfil, identificar oportunidades e realizar oferta e contratação de
          produtos, serviços, iniciativas e benefícios da TRAVEL GEA e/ou de parceiros
          estratégicos mais adequados ao perfil, interesses e necessidades, para clientes
          atuais, potenciais e terceiros, inclusive por meio de e-mail marketing ou outras
          comunicações. Você pode gerenciar os meios pelos quais prefere receber nossas
          ofertas ou optar por não mais recebê-las em nossos canais de atendimento;
        </li>
        <br />
      </ul>
      <ol style={{ listStyle: 'auto', paddingLeft: '1rem' }}>
        <li>
          analisar informações demográficas e de interesses dos Usuários, por meio de
          ferramentas de analytics como Google Analytics e Facebook Ads, visando compreender
          o público-alvo das campanhas de publicidade;
        </li>
        <br />
        <li>
          avaliar os comportamentos de navegação e o perfil dos Usuários e clientes,
          inclusive para entender se o Usuário chegou até os Sites e Aplicativos por meio de
          acesso direto, links ou cookies próprios ou de terceiros, por exemplo;
        </li>
        <br />
        <li>
          realizar campanhas de marketing e utilizar tecnologias da informação e soluções de
          propaganda online;
        </li>
        <br />
        <li>
          realizar pesquisas com o público para melhoria dos nossos produtos, serviços,
          atendimento e iniciativas.
        </li>
        <br />
        <li>
          realizar análises estratégicas de produtos e serviços contratados em outras
          Plataformas de viagem para evolução dos nossos próprios produtos e serviços e para
          oferecer produtos e serviços mais adequados ao seu perfil.
        </li>
        <br />
      </ol>

      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>Segurança e risco:</li>
        <br />
        <li>
          identificar, prevenir e gerenciar eventuais riscos de segurança, física ou
          cibernética, sua, da TRAVEL GEA ou de terceiros;
        </li>
        <br />

        <li>cumprir ordens e decisões judiciais, administrativas e arbitrais.</li>
        <br />
        <li>Proteger os seus direitos, da TRAVEL GEA e de terceiros:</li>
        <br />
        <li>
          para o exercício regular de direitos, inclusive em contratos e processos
          judiciais, extrajudiciais, administrativos ou arbitrais.
        </li>
        <br />
        <li>Manter, criar e melhorar as nossas atividades:</li>
        <br />
        <li>
          analisar, criar e aperfeiçoar os nossos produtos, serviços, atividades, sejam
          internas ou externas, iniciativas, projetos, recursos e funcionalidades das nossas
          plataformas, Sites e Aplicativos, inclusive para melhorar o seu acesso e
          utilização e fornecer a melhor experiência para você;
        </li>
        <br />
      </ul>

      <ol style={{ listStyle: 'auto', paddingLeft: '1rem' }}>
        <li>
          medir e entender a interação dos Usuários e clientes conosco, inclusive em redes
          sociais e em nossos canais, assim como a utilização dos nossos produtos, serviços,
          atividades, iniciativas, Sites e Aplicativos e a satisfação dos Usuários e
          clientes. Assim podemos criar, manter e melhorar os nossos produtos, serviços e
          nossos canais de atendimento;
        </li>
        <br />
        <li>
          execução de processos de negócios, gerenciamento interno e gerencial. Tratamos
          seus dados para nossas atividades e para nos ajudar a tomar melhores decisões
          sobre nossas operações, negócios, serviços, produtos, atividades e iniciativas;
        </li>
        <br />
        <li>
          atividades relacionadas à contratação e relacionamento com fornecedores,
          prestadores de serviços e outros terceiros.
        </li>
        <br />
      </ol>

      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>
          Outras situações de Tratamento baseadas em finalidades legítimas, como por exemplo
          o apoio e promoção de atividades da TRAVEL GEA ou para a prestação de serviços que
          beneficiem os nossos clientes.
        </li>
        <br />
        <li>Promover eventos, realizar patrocínios e outras atividades e iniciativas.</li>
        <br />
      </ul>
    </section>

    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        4. AS INFORMAÇÕES PODEM SER COMPARTILHADAS?
      </h4>
      <p>
        A TRAVEL GEA somente compartilha suas informações quando é necessário ou pertinente
        para as finalidades previstas nos contratos com os nossos clientes e nessa Política
        de Privacidade, dentro de padrões rígidos de segurança, sempre visando a
        confidencialidade das suas informações e seguindo as normas de sigilo bancário e
        demais normas de proteção de dados e da privacidade.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        5. TRANSFERÊNCIA INTERNACIONAL DE DADOS
      </h4>
      <p>
        Os seus Dados Pessoais poderão ser transferidos e tratados em outros países, de
        acordo com as hipóteses previstas na LGPD e legislação aplicável, para as
        finalidades previstas nesta Política de Privacidade.
      </p>
      <p>
        Por exemplo, os dados podem ser transferidos para o exterior caso seja necessário
        para a execução de contrato; para o cumprimento de obrigações legais e regulatórias
        da TRAVEL GEA; para o exercício regular de direitos em processos administrativos,
        judiciais ou arbitrais ou para a investigação de crimes e outros ilícitos. Ainda, a
        transferência internacional de dados pode ocorrer para o desenvolvimento das
        atividades da TRAVEL GEA, mediante a adoção de medidas de proteção dos Dados
        Pessoais.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>
        6. POR QUANTO TEMPO MANTEMOS SEUS DADOS?
      </h4>
      <p>
        O prazo pelo qual a TRAVEL GEA mantém os Dados Pessoais coletados depende do
        propósito e da natureza do tratamento dos dados. Nós trataremos seus dados pelo
        período necessário para o cumprimento de obrigações legais, regulatórias e
        contratuais, para continuar a fornecer e aprimorar nossos produtos e serviços, para
        o gerenciamento de riscos, para o exercício regular de direito em processos
        administrativos, judiciais e arbitrais e para as demais finalidades previstas nesta
        Política de Privacidade.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>7. SEGURANÇA DOS DADOS</h4>
      <p>
        A segurança e proteção de dados pessoais e das informações da TRAVEL GEA é uma
        prioridade para nós. A TRAVEL GEA estabelece processos e controles para prevenção,
        detecção e resposta a incidentes e proteção dos seus dados de acessos e usos não
        autorizados, garantindo a gestão do risco de segurança, inclusive cibernética, e a
        construção de um alicerce robusto de segurança.
      </p>
      <p>
        Consideramos que a informação deve ser protegida independentemente de onde ela
        esteja, seja em um prestador de serviço ou em uma unidade internacional, ou em
        parceiro, em todo o seu ciclo de vida, desde o momento que ela é coletada, passando
        pelo processamento, transmissão, armazenamento, análise e seu descarte.
      </p>
      <p>
        Cuidamos dos dados seguindo padrões rígidos de segurança e confidencialidade, para
        fornecer aos nossos usuários e clientes um ambiente seguro e confiável. Usamos
        ferramentas e tecnologias para manter a integridade e confidencialidade das
        informações e protegê-las de acessos não autorizados.
      </p>
    </section>
    <section className='mb-8'>
      <h4 className='text-base text-gray-400 font-bold mb-4'>8. SEUS DIREITOS</h4>
      <p>
        A LGPD garante direitos aos Titulares dos Dados. Como Titular dos seus Dados
        Pessoais, você pode nos fazer os seguintes requerimentos:
      </p>
      <ul style={{ listStyle: 'disc', paddingLeft: '1rem' }}>
        <li>acesso e confirmação da existência de tratamento dos dados pessoais;</li>
        <br />
        <li>atualização, correção de dados incompletos, inexatos ou desatualizados;</li>
        <br />
        <li>
          anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou
          tratados em desconformidade com o disposto na LGPD;
        </li>
        <br />
        <li>
          portabilidade dos dados, observadas as normas aplicáveis e os segredos comercial e
          industrial;
        </li>
        <br />
        <li>
          informação das entidades públicas e privadas com as quais o Controlador realizou
          uso compartilhado de dados;
        </li>
        <br />
        <li>
          informação sobre a possibilidade de não fornecer consentimento e sobre as
          consequências da negativa;
        </li>
        <br />
        <li>
          revogação de consentimento que poderá ser realizada a qualquer momento e sem ônus,
          mediante manifestação expressa;
        </li>
        <br />
        <li>
          solicitar a eliminação dos Dados Pessoais Tratados com o consentimento, exceto nas
          hipóteses em que a manutenção dos dados é necessária ou permitida pela legislação;
        </li>
        <br />
        <li>
          oposição a Tratamento realizado com fundamento em outras bases legais, em caso de
          descumprimento da LGPD, ressaltando que pode haver situações em que poderemos
          continuar a realizar o Tratamento e recusar o seu pedido de oposição;
        </li>
        <br />
        <li>
          solicitar a revisão de decisões tomadas unicamente com base em Tratamento
          automatizado de Dados Pessoais que o afetem, como decisões de crédito;
        </li>
        <br />
        <li>
          solicitar o cancelamento do envio de ofertas direcionadas de produtos e serviços
          da TRAVEL GEA pelos nossos canais.
        </li>
        <br />
      </ul>
      <p>
        Para exercer seus direitos sobre os seus Dados Pessoais, você pode acionar os nossos
        canais de atendimento.
      </p>
      <br />
      <p>
        Reforçamos que poderemos manter alguns dados e/ou continuar a realizar o Tratamento,
        mesmo no caso de solicitação de eliminação, oposição, bloqueio ou anonimização, em
        algumas circunstâncias, como para cumprimento de obrigações legais, contratuais e
        regulatórias, para resguardar e exercer direitos da TRAVEL GEA, dos Usuários e
        clientes, para prevenção de atos ilícitos e em processos judiciais, administrativos
        e arbitrais, inclusive por questionamento de terceiros sobre suas atividades e em
        outras hipóteses previstas em lei.
      </p>
    </section>
    </div>
  );
}
